import { TerminalTypesInfo } from "../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getTerminalTypesCall"

/* eslint-disable */
export enum NumberingOptions {
  manual = "Manual",
  automatic = "Automatic"
}

export enum StartCornerOptions {
  topLeft = "top-left",
  topRight = "top-right",
  bottomLeft = "bottom-left",
  bottomRight = "bottom-right"
}

export enum DirectionOptions {
  horizontal = "horizontal",
  vertical = "vertical"
}

export enum PatternOptions {
  z = "Z",
  u = "U"
}
/* eslint-enable */

export interface Pen {
  id: string
  penId: string | null
  name?: string
  visual?: string;
  io: number | null
  feederOutput?: number | null
  waterOutput?: number | null
  activatorInput?: number | null
  feederOutputConfig?: Omit<TerminalTypesInfo, "input">
  waterOutputConfig?: TerminalTypesInfo
  activatorInputConfig?: TerminalTypesInfo
}

export interface Section {
  lanController: string,
  pens: Pen[];
  feederOnly?: boolean
  water?: boolean
  activator?: boolean
  columns: number;
  rows?: number;
  name?: string,
  numbering?: NumberingOptions,
  startCorner?: StartCornerOptions,
  direction?: DirectionOptions,
  pattern?: PatternOptions
}
